import { render } from "./CustomAreaCategoriesUpsert.vue?vue&type=template&id=6740d294"
import script from "./CustomAreaCategoriesUpsert.vue?vue&type=script&lang=js"
export * from "./CustomAreaCategoriesUpsert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__